import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikOn extends ASTBlock {
    constructor(color) {
        super(color, "alvik_on")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "Alvik an? %1",
            "args0": [{
                "type": "input_dummy",
                "name": "NAME"
            }],
            "output": "Boolean"
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}